import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import { ChangeDetectionStrategy, Component, Signal, inject, isSignal, signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { FormsModule } from '@angular/forms';
import { Observable } from 'rxjs';

@Component({
  selector: 'woo-base-modal',
  imports: [FormsModule],
  template: ``,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BaseModalComponent<T = unknown> {
  dialogRef = inject(DialogRef);
  public modaldata: Signal<T> = this.coerceSignal<T>(inject(DIALOG_DATA) as T);

  public close(): void {
    this.dialogRef.close();
  }

  private coerceSignal<T>(source: Signal<T> | Observable<T> | T, initial?: T): Signal<T> {
    if (isSignal(source)) {
      return source;
    }
    if (source instanceof Observable) {
      return toSignal(source, { initialValue: initial });
    }
    return signal(source as T);
  }
}
